export default __webpack_public_path__ + "static/media/002-send.765a808a.png";